import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ColorService {
  private mix(c: number, alpha: number): string {
    return Math.round(c * alpha + 255 * (1 - alpha))
      .toString(16)
      .padStart(2, '0');
  }

  mixWithWhite(hex: string, alpha: number): string {
    if (!hex) {
      return '';
    }

    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return `#${this.mix(r, alpha)}${this.mix(g, alpha)}${this.mix(b, alpha)}`;
  }
}
